import { render } from "./mvt-article.presentational.vue?vue&type=template&id=89fb01da"
import script from "./mvt-article.presentational.vue?vue&type=script&lang=js"
export * from "./mvt-article.presentational.vue?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__